// Curated list of UK towns, cities and regions for location suggestions.
export const UK_LOCATIONS = [
  "London", "Central London", "East London", "West London", "North London", "South London",
  "Birmingham", "Manchester", "Leeds", "Liverpool", "Sheffield",
  "Newcastle upon Tyne", "Sunderland", "Durham", "Middlesbrough",
  "Nottingham", "Leicester", "Derby", "Coventry", "Wolverhampton",
  "Stoke-on-Trent", "Bristol", "Bath", "Exeter", "Plymouth",
  "Southampton", "Portsmouth", "Brighton", "Hove", "Reading", "Slough",
  "Oxford", "Cambridge", "Milton Keynes", "Northampton", "Peterborough",
  "Luton", "Bedford", "Ipswich", "Norwich", "Colchester", "Chelmsford",
  "Southend-on-Sea", "Watford", "St Albans", "Guildford", "Woking",
  "Swindon", "Gloucester", "Cheltenham", "Worcester", "Hereford",
  "Shrewsbury", "Telford", "Walsall", "Dudley", "Solihull", "Nuneaton",
  "Warwick", "Stratford-upon-Avon", "Rugby", "Stafford", "Cannock",
  "Lincoln", "Grimsby", "Scunthorpe", "Hull", "York", "Harrogate",
  "Bradford", "Huddersfield", "Halifax", "Wakefield", "Doncaster",
  "Rotherham", "Barnsley", "Chesterfield", "Mansfield", "Warrington",
  "Chester", "Crewe", "Stockport", "Bolton", "Bury", "Rochdale",
  "Oldham", "Wigan", "Blackburn", "Preston", "Blackpool", "Lancaster",
  "Carlisle", "Barrow-in-Furness", "Kendal", "Gateshead", "South Shields",
  "Hartlepool", "Darlington", "Stockton-on-Tees", "Aberdeen", "Dundee",
  "Edinburgh", "Glasgow", "Paisley", "Stirling", "Inverness", "Perth",
  "Cardiff", "Swansea", "Newport", "Wrexham", "Belfast", "Derry",
  "Bangor", "Canterbury", "Maidstone", "Dover", "Ashford", "Tunbridge Wells",
  "Hastings", "Eastbourne", "Worthing", "Crawley", "Basingstoke",
  "Aldershot", "Farnborough", "Andover", "Salisbury", "Bournemouth",
  "Poole", "Weymouth", "Taunton", "Yeovil", "Truro", "Torquay",
  // wider coverage: towns across every UK region
  "Aylesbury", "High Wycombe", "Maidenhead", "Windsor", "Bracknell", "Newbury",
  "Didcot", "Abingdon", "Witney", "Banbury", "Bicester", "Henley-on-Thames",
  "Stevenage", "Hemel Hempstead", "Welwyn Garden City", "Hatfield", "Hitchin",
  "Cirencester", "Stroud", "Tewkesbury", "Leamington Spa", "Bedworth",
  "Redditch", "Bromsgrove", "Kidderminster", "Stourbridge", "Halesowen",
  "Burton upon Trent", "Tamworth", "Lichfield", "Newcastle-under-Lyme",
  "Grantham", "Boston", "Skegness", "King's Lynn", "Great Yarmouth", "Thetford",
  "Bury St Edmunds", "Lowestoft", "Felixstowe", "Basildon", "Harlow", "Braintree",
  "Dartford", "Gillingham", "Folkestone", "Margate", "Sevenoaks", "Tonbridge",
  "Epsom", "Redhill", "Farnham", "Camberley", "Winchester", "Fareham", "Eastleigh",
  "Bognor Regis", "Horsham", "Chichester", "Dorchester", "Bridgwater",
  "Weston-super-Mare", "Chippenham", "Trowbridge", "Paignton", "Barnstaple",
  "St Austell", "Newquay", "Falmouth", "Penzance", "Burnley", "Morecambe",
  "Accrington", "Chorley", "St Helens", "Southport", "Birkenhead", "Wallasey",
  "Runcorn", "Widnes", "Ellesmere Port", "Macclesfield", "Northwich", "Wilmslow",
  "Scarborough", "Selby", "Beverley", "Bridlington", "Bishop Auckland",
  "Workington", "Whitehaven", "Bridgend", "Merthyr Tydfil", "Barry", "Llanelli",
  "Carmarthen", "Aberystwyth", "Falkirk", "Kilmarnock", "Ayr", "Dumfries",
  "Motherwell", "Hamilton", "Kirkcaldy", "Dunfermline", "Livingston", "Coatbridge",
  "Lisburn", "Newry", "Croydon", "Bromley", "Ilford", "Romford", "Hounslow",
  "Ealing", "Enfield", "Harrow", "Wembley", "Kingston upon Thames", "Sutton",
  "Barking", "Dagenham", "Walthamstow", "Lewisham", "Brixton", "Hackney",
  "Islington", "Hammersmith", "Fulham", "Stratford", "Canary Wharf",
  // regions and counties
  "Greater London", "Greater Manchester", "West Midlands", "West Yorkshire", "South Yorkshire",
  "Merseyside", "Tyne and Wear", "Kent", "Essex", "Surrey", "Hampshire", "Hertfordshire",
  "Berkshire", "Buckinghamshire", "Oxfordshire", "Cambridgeshire", "Norfolk", "Suffolk",
  "Devon", "Cornwall", "Somerset", "Dorset", "Wiltshire", "Gloucestershire",
  "Warwickshire", "Staffordshire", "Leicestershire", "Nottinghamshire", "Derbyshire",
  "Lancashire", "Cheshire", "Cumbria", "Northumberland", "County Durham", "Lincolnshire",
  "North Yorkshire", "East Sussex", "West Sussex", "Northamptonshire", "Bedfordshire",
  "Shropshire", "Herefordshire", "Worcestershire", "Aberdeenshire", "Mid Glamorgan",
  "West Glamorgan", "Gwent", "Central Scotland", "Scottish Highlands", "Northern Ireland",
];

// UK postcode areas -> main town, so typed postcodes are recognised too
export const POSTCODE_AREAS = {
  AB: "Aberdeen", AL: "St Albans", B: "Birmingham", BA: "Bath", BB: "Blackburn",
  BD: "Bradford", BH: "Bournemouth", BL: "Bolton", BN: "Brighton", BR: "Bromley",
  BS: "Bristol", BT: "Belfast", CA: "Carlisle", CB: "Cambridge", CF: "Cardiff",
  CH: "Chester", CM: "Chelmsford", CO: "Colchester", CR: "Croydon", CT: "Canterbury",
  CV: "Coventry", CW: "Crewe", DA: "Dartford", DD: "Dundee", DE: "Derby",
  DG: "Dumfries", DH: "Durham", DL: "Darlington", DN: "Doncaster", DT: "Dorchester",
  DY: "Dudley", E: "East London", EC: "Central London", EH: "Edinburgh",
  EN: "Enfield", EX: "Exeter", FK: "Falkirk", FY: "Blackpool", G: "Glasgow",
  GL: "Gloucester", GU: "Guildford", HA: "Harrow", HD: "Huddersfield",
  HG: "Harrogate", HP: "Hemel Hempstead", HR: "Hereford", HU: "Hull",
  HX: "Halifax", IG: "Ilford", IP: "Ipswich", IV: "Inverness", KA: "Kilmarnock",
  KT: "Kingston upon Thames", KW: "Kirkwall", KY: "Kirkcaldy", L: "Liverpool",
  LA: "Lancaster", LD: "Llandrindod Wells", LE: "Leicester", LL: "Llandudno",
  LN: "Lincoln", LS: "Leeds", LU: "Luton", M: "Manchester", ME: "Rochester",
  MK: "Milton Keynes", ML: "Motherwell", N: "North London", NE: "Newcastle upon Tyne",
  NG: "Nottingham", NN: "Northampton", NP: "Newport", NR: "Norwich",
  NW: "North West London", OL: "Oldham", OX: "Oxford", PA: "Paisley",
  PE: "Peterborough", PH: "Perth", PL: "Plymouth", PO: "Portsmouth", PR: "Preston",
  RG: "Reading", RH: "Redhill", RM: "Romford", S: "Sheffield", SA: "Swansea",
  SE: "South East London", SG: "Stevenage", SK: "Stockport", SL: "Slough",
  SM: "Sutton", SN: "Swindon", SO: "Southampton", SP: "Salisbury", SR: "Sunderland",
  SS: "Southend-on-Sea", ST: "Stoke-on-Trent", SW: "South West London",
  SY: "Shrewsbury", TA: "Taunton", TD: "Galashiels", TF: "Telford",
  TN: "Tunbridge Wells", TQ: "Torquay", TR: "Truro", TS: "Middlesbrough",
  TW: "Twickenham", UB: "Uxbridge", W: "West London", WA: "Warrington",
  WC: "Central London", WD: "Watford", WF: "Wakefield", WN: "Wigan",
  WR: "Worcester", WS: "Walsall", WV: "Wolverhampton", YO: "York", ZE: "Lerwick",
};

export function suggestLocations(input, limit = 8) {
  const raw = (input || "").trim();
  const q = raw.toLowerCase();
  if (q.length < 2) return [];
  const out = UK_LOCATIONS.filter((l) => l.toLowerCase().includes(q));
  // typed a postcode (or its start, e.g. "LS1"): offer the outward code, which the
  // search expands to the whole postcode area and its main town
  const pc = raw.toUpperCase().replace(/\s+/g, "");
  const m = pc.match(/^([A-Z]{1,2})(\d[A-Z0-9]?)?/);
  if (m && m[2] && POSTCODE_AREAS[m[1]]) {
    out.unshift(`${m[1]}${m[2]}`);
  }
  return out.slice(0, limit);
}
